import React, { useEffect, useState } from "react";
import {
	Form,
	Button,
	Popconfirm,
	message,
	Modal,
	Spin,
	Table,
	Input,
	ColorPicker,
} from "antd";
import {
	useGetProductListQuery,
	useAddProductMutation,
	useDeleteProductMutation,
	useUpdateProductMutation,
} from "@/redux/services/productApi";

const Add = () => {
	const [form] = Form.useForm();
	const [isOpen, setIsOpen] = useState(false);
	const [color, setColor] = useState("#000000");

	const [addProduct] = useAddProductMutation();
	const { refetch } = useGetProductListQuery();

	const onFinish = async (values) => {
		await addProduct({
			...values,
			product_color: color
		})
			.unwrap()
			.then((payload) => {
				refetch();
				form.resetFields();
				setIsOpen(false);
				message.success("Create successful");
			})
			.catch((error) => message.error("Something went wrong..."));
	};

	const handleCancel = () => {
		form.resetFields();
		setColor("");
		setIsOpen(false);
	};

	return (
		<div>
			<Button
				style={{ marginBottom: "30px" }}
				onClick={() => setIsOpen(true)}
			>
				新产品
			</Button>
			<Modal
				title="Create A Product"
				open={isOpen}
				onCancel={handleCancel}
				footer={[
					<Button key="cancel" onClick={handleCancel}>
						Cancel
					</Button>,
				]}
				width="60%"
			>
				<Form
					form={form}
					onFinish={onFinish}
					labelCol={{ span: 8 }}
					wrapperCol={{ span: 16 }}
					style={{ maxWidth: 600, marginTop: "30px" }}
				>
					<Form.Item
						name="product_id"
						label="产品 ID"
						rules={[{ required: true, message: "请输入产品ID" }]}
					>
						<Input />
					</Form.Item>
					<Form.Item
						name="product_title"
						label="名字"
						rules={[{ required: true, message: "请输入产品名字" }]}
					>
						<Input />
					</Form.Item>
					<Form.Item
						name="product_subtitle"
						label="副标题"
						rules={[
							{ required: true, message: "请输入产品副标题" },
						]}
					>
						<Input />
					</Form.Item>
					<Form.Item
						name="product_description"
						label="描述"
						rules={[{ required: true, message: "请输入产品描述" }]}
					>
						<Input />
					</Form.Item>

					<Form.Item
						label="颜色"
					>
						<ColorPicker value={color}
							onChangeComplete={(color) => {
								setColor(color.toHexString());
							}} />
					</Form.Item>

					<Form.Item wrapperCol={{ offset: 8, span: 16 }}>
						<Button type="primary" htmlType="submit">
							Submit
						</Button>
					</Form.Item>
				</Form>
			</Modal>
		</div>
	);
};

const Edit = ({ item, isOpen, handleClose }) => {
	const [form] = Form.useForm();
	const [updateProduct] = useUpdateProductMutation();
	const [color, setColor] = useState("#000000");

	const handleCancel = () => {
		handleClose();
	};

	const onFinish = async (values) => {
		// try {
		// 	await updateProduct({
		// 		...values,
		// 	});
		// 	message.success("Update successful");
		// 	handleCancel();
		// } catch (error) {
		// 	message.error("Something went wrong...");
		// }

		await updateProduct({
			...values,
			product_color: color
		})
			.unwrap()
			.then((payload) => {
				message.success("Update successful");
				handleCancel();
			})
			.catch((error) => message.error("Something went wrong..."));
	};

	useEffect(() => {
		form.setFieldsValue(item); // 确保每次 item 更新时，更新表单的字段值
		setColor(item?.product_color ?? "#000000");
	}, [form, item]);

	return (
		<div>
			<Modal
				title="Edit Product"
				open={isOpen}
				onCancel={handleCancel}
				footer={[
					<Button key="cancel" onClick={handleCancel}>
						Cancel
					</Button>,
				]}
				width="60%"
			>
				<Form
					form={form}
					onFinish={onFinish}
					labelCol={{ span: 8 }}
					wrapperCol={{ span: 16 }}
					style={{ maxWidth: 600, marginTop: "30px" }}
					initialValues={item}
				>
					<Form.Item
						name="product_id"
						label="产品 ID"
						rules={[
							{
								required: true,
								message: "请输入产品ID",
							},
						]}
					>
						<Input disabled />
					</Form.Item>
					<Form.Item
						name="product_title"
						label="名字"
						rules={[{ required: true, message: "请输入产品名字" }]}
					>
						<Input />
					</Form.Item>
					<Form.Item
						name="product_subtitle"
						label="副标题"
						rules={[
							{ required: true, message: "请输入产品副标题" },
						]}
					>
						<Input />
					</Form.Item>
					<Form.Item
						name="product_description"
						label="描述"
						rules={[{ required: true, message: "请输入产品描述" }]}
					>
						<Input />
					</Form.Item>

					<Form.Item
						label="颜色"
					>
						<ColorPicker
							value={color}
							onChangeComplete={(color) => {
								setColor(color.toHexString());
							}} />
					</Form.Item>

					<Form.Item wrapperCol={{ offset: 8, span: 16 }}>
						<Button type="primary" htmlType="submit">
							Submit
						</Button>
					</Form.Item>
				</Form>
			</Modal>
		</div>
	);
};

const Product = () => {
	const { data, isLoading, isError, refetch } = useGetProductListQuery();
	const [deleteProduct] = useDeleteProductMutation();
	const [isOpenEdit, setIsOpenEdit] = useState(false);
	const [editItem, setEditItem] = useState();

	const handleClose = async () => {
		await refetch();
		setIsOpenEdit(false);
		setEditItem(undefined);
	};

	const handleDelete = async (item) => {
		try {
			await deleteProduct(item.product_id);
			message.success(`${item.product_title} delete successful!`);
			refetch();
		} catch (error) {
			message.error("something went wrong");
			console.log("error", error);
		}
	};

	const columns = [
		{
			title: "产品 ID",
			dataIndex: "product_id",
			key: "product_id",
			editable: true,
		},
		{
			title: "名字",
			dataIndex: "product_title",
			key: "product_title",
			editable: true,
		},
		{
			title: "副标题",
			dataIndex: "product_subtitle",
			key: "product_subtitle",
			editable: true,
		},
		{
			title: "描述",
			dataIndex: "product_description",
			key: "product_description",
			editable: true,
		},
		{
			title: "颜色",
			dataIndex: "product_color",
			key: "product_color",
			render: (item) => {
				return (
					<div
						style={{
							display: 'flex',
							justifyContent: 'left',
							alignItems: 'center',
							height: '100%',
						}}
					>
						<div
							style={{
								width: 24,
								height: 24,
								backgroundColor: item ?? "#000000",
								border: '1px solid #ddd',
							}}
						/>
					</div>
				)
			}
		},
		{
			title: "修改",
			dataIndex: "",
			key: "x",
			render: (item) => {
				return (
					<Button
						onClick={() => {
							setIsOpenEdit(true);
							setEditItem(item);
						}}
					>
						Edit
					</Button>
				);
			},
		},
		{
			title: "删除",
			dataIndex: "",
			key: "x",
			render: (item) => {
				return (
					<Popconfirm
						title="Delete the product"
						description="Are you sure to delete this product?"
						onConfirm={() => handleDelete(item)}
						okText="Yes"
						cancelText="No"
					>
						<Button danger>Delete</Button>
					</Popconfirm>
				);
			},
		},
	];

	if (isLoading) {
		return <Spin />;
	}

	if (isError) {
		return <div>something went wrong</div>;
	}
	return (
		<div>
			<Add />
			<Table dataSource={data} columns={columns} />
			<Edit
				handleClose={handleClose}
				isOpen={isOpenEdit}
				item={editItem}
			/>
		</div>
	);
};

export default Product;
